function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
        return Math[type](value);
    }
    let valToEvaluate = +value;
    const expToEvaluate = +exp;

    // If the value is not a number or the exp is not an integer...
    if (
        valToEvaluate === null ||
        Number.isNaN(Number(valToEvaluate)) ||
        !(typeof expToEvaluate === 'number' && expToEvaluate % 1 === 0)
    ) {
        return NaN;
    }

    // If the value is negative...
    if (valToEvaluate < 0) {
        return -decimalAdjust(type, -valToEvaluate, expToEvaluate);
    }

    // Shift
    valToEvaluate = valToEvaluate.toString().split('e');
    valToEvaluate = Math[type](
        +`${valToEvaluate[0]}e${valToEvaluate[1] ? +valToEvaluate[1] - expToEvaluate : -expToEvaluate}`
    );

    // Shift back
    valToEvaluate = valToEvaluate.toString().split('e');
    return +`${valToEvaluate[0]}e${valToEvaluate[1] ? +valToEvaluate[1] + expToEvaluate : expToEvaluate}`;
}

export const round10 = (value, exp) => decimalAdjust('round', value, exp);

export const floor10 = (value, exp) => decimalAdjust('round', value, exp);

export const ceil10 = (value, exp) => decimalAdjust('ceil', value, exp);

export const convertCentsToUSD = (amount = 0) =>
    (amount / 100).toLocaleString('en-us', { style: 'currency', currency: 'USD' });

export const calculatePercentage = (numerator, denominator) => {
    if (!denominator || Number.isNaN(Number(denominator))) {
        return 0;
    }

    if (!numerator || Number.isNaN(Number(denominator))) {
        return 0;
    }

    if (typeof numerator !== 'number' || typeof denominator !== 'number') {
        return 0;
    }

    return Math.round((numerator / denominator) * 100);
};

export const getRandomInt = (max, min) => Math.floor(Math.random() * (max - min)) + min;

/**
 *
 * @param {string} string
 * @param {number} max
 */
export const generateNumberFromString = (string, max) =>
    max ? (Number(((string || '0').match(/\d+/g) || []).join('')) || 0) % max : 0;

export const getFileSize = (fileSize) => {
    let size = Math.round(fileSize / 1024);

    if (size > 1024) {
        size = Math.round(size / 1024);
    } else {
        return `${size}KB`;
    }
    return `${size}MB`;
};
